/* eslint-disable react/prop-types */
import * as React from 'react';
import isNil from 'lodash/isNil';
import omit from 'lodash/omit';

type HOCProps = {
  className?: string,
  hash?: string,
  suppressReplaceState?: boolean
};

export function withScrollTo(WrappedComponent, props: HOCProps = { hash: '', suppressReplaceState: false }) {
  class ScrollTo extends React.PureComponent<React.ComponentProps<typeof WrappedComponent>> {
    static displayName = `ScrollToHOC(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    scrollToRef: React.RefObject<HTMLInputElement> = React.createRef();

    componentDidMount() {
      const { hash } = this.props;

      if (hash === '') {
        return;
      }

      if (window.location.hash.slice(1) === hash) {
        setTimeout(() => {
          if (isNil(this.scrollToRef.current)) {
            return;
          }

          this.scrollToRef.current.scrollIntoView();

          // Remove hash from url without reloading the page
          if (!props.suppressReplaceState) {
            history.replaceState( // eslint-disable-line no-undef,no-restricted-globals
              '', document.title, window.location.href.split('#')[0]
            );
          }
        }, 100);
      }
    }

    render() {
      return (
        <div
          ref={this.scrollToRef}
          {...omit(props, 'suppressReplaceState')}
        >
          <WrappedComponent
            {...omit(this.props, 'hash')}
          />
        </div>
      );
    }
  }

  return ScrollTo;
}
